import { render, staticRenderFns } from "./ModalVerificaIdentidade.vue?vue&type=template&id=788616a5&scoped=true"
import script from "./ModalVerificaIdentidade.vue?vue&type=script&lang=js"
export * from "./ModalVerificaIdentidade.vue?vue&type=script&lang=js"
import style0 from "./ModalVerificaIdentidade.vue?vue&type=style&index=0&id=788616a5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "788616a5",
  null
  
)

export default component.exports